import { render, staticRenderFns } from "./TeresaTab.vue?vue&type=template&id=9a069cc0&scoped=true&"
import script from "./TeresaTab.vue?vue&type=script&lang=js&"
export * from "./TeresaTab.vue?vue&type=script&lang=js&"
import style0 from "./TeresaTab.vue?vue&type=style&index=0&id=9a069cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a069cc0",
  null
  
)

export default component.exports